/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _AccommodationInvoiceRefundState = {
  id: null,
  amount: '',
  reason: '',
  note: ''
}

class AccommodationInvoiceRefundState extends Record(_AccommodationInvoiceRefundState) {
  canRefund() {
    return this.amount.length > 0
  }
}

export { AccommodationInvoiceRefundState }
